<template>
	<section class="section">
		<div class="container-fluid">
			<card ref="card" title="" icon="">
				<form-field label="企業名" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
						<input class="input" :class="{'is-danger': hasError('name')}" type="text" v-model="name">
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('name')">{{ errors.name }}</p>
					</div>
				</form-field>

				<form-field label="郵便番号" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<input class="input" :class="{'is-danger': hasError('zip')}" type="text" v-model="zip">
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('zip')">{{ errors.zip }}</p>
					</div>
				</form-field>

				<form-field label="住所" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<input class="input" :class="{'is-danger': hasError('address')}" type="text" v-model="address">
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('address')">{{ errors.address }}</p>
					</div>
				</form-field>

				<form-field label="電話番号" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<input class="input" :class="{'is-danger': hasError('tel')}" type="text" v-model="tel">
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('tel')">{{ errors.tel }}</p>
					</div>
				</form-field>

				<form-field label="メモ" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<textarea class="textarea" v-model="memo"></textarea>
						</p>
					</div>
				</form-field>

				<form-field class="mt-20" label=" " sub=" " :has-wrap="false">
					<b-checkbox v-model="isHidden">サービス停止</b-checkbox>
				</form-field>

				<form-field :has-wrap="false">
					<div class="edit-buttons">
						<b-button type="is-light" @click="onBackButtonClick">戻る</b-button>
						<b-button type="is-success" :loading="isLoading" @click="onRegisterButtonClick">登録</b-button>
					</div>
				</form-field>
			</card>
		</div>
	</section>
</template>

<script>
import Card from '@/components/Card'
import FormField from '@/components/FormField'
import CheckboxGroup from '@/components/CheckboxGroup'

export default {
	name: "customer-edit",
	components: {
		Card,
		FormField,
		CheckboxGroup,
	},
	data() {
		return {
			isLoading: false,
			isPwdResetLoading: false,
			customerStatusId: '',
			customerStatuses: null,
			id: '',
			name: '',
			tel: '',
			address: '',
			zip: '',
			memo: '',
			isHidden: false,
			errors: {
				name: '',
				address: '',
				tel: '',
				zip: '',
			}
		}
	},
	computed: {
	},
	mounted() {
		let subTitle = this.$route.params.customerId ? '更新' : '新規作成';
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['企業管理', subTitle]
		})
		this.getData();
	},
	methods: {
		hasError: function(key) {
			return this.errors[key] !== '';
		},
		getData: async function() {
			let loading = this.$loading.open();
			let params = this.$route.params.customerId ? '/' + this.$route.params.customerId : '';
			let ep = 'customers/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.name = res.data.name;
				this.address = res.data.address;
				this.zip = res.data.zip;
				this.tel = res.data.tel;
				this.memo = res.data.memo;
				this.isHidden = res.data.is_hidden;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		onRegisterButtonClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"name": this.name,
				"address": this.address,
				"zip": this.zip,
				"tel": this.tel,
				"memo": this.memo,
				"is_hidden": this.isHidden ? 1 : 0,
			};
			this.$utils.log(data);

			let ep = 'customers';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$router.push({ name: 'customer' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		onBackButtonClick: function() {
			this.$router.go(-1);
		},
	}
}
</script>

<style scoped>
</style>
